import * as fromRouter from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterStateUrl } from './router-state-url';

export const selectRouterState =
  createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>('routerReducer');

export const selectRouteData = createSelector(
  selectRouterState,
  (routerState) => routerState?.state.data
);

export const selectRouteParams = createSelector(
  selectRouterState,
  (routerState) => routerState?.state?.params
);

export const selectRouteUrl = createSelector(
  selectRouterState,
  (routerState) => routerState?.state?.url
);

export const selectRouteParam = (paramName: string) =>
  createSelector(selectRouteParams, (params) => params?.[paramName] as string | undefined);

export const selectRouteQueryParams = createSelector(
  selectRouterState,
  (routerState) => routerState?.state.queryParams
);

export const selectHasSelectedLegalEntity = createSelector(
  selectRouteParam(`legalEntityId`),
  (legalEntityId) => !!legalEntityId
);

export const selectRouteQueryParam = (paramName: string) =>
  createSelector(
    selectRouteQueryParams,
    (queryParams) => queryParams?.[paramName] as string | undefined
  );
